const resources = {
    giftCardTitle: 'Gift Card',
    free: 'Free'
};

export default function getResource(label) {
    return resources[label];
}
